import { indexData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '热播': 'bg-primary-100 text-primary-700',
  '推荐': 'bg-accent-100 text-accent-700',
  '高分': 'bg-secondary-100 text-secondary-700',
  '清新': 'bg-green-100 text-green-700',
  '热血': 'bg-orange-100 text-orange-700',
  '欢乐': 'bg-yellow-100 text-yellow-700',
  '烧脑': 'bg-purple-100 text-purple-700',
  '浪漫': 'bg-pink-100 text-pink-700',
  '二次元': 'bg-cyan-100 text-cyan-700',
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">专题合集</h2>
          <p className="mt-2 text-sm text-foreground-500">分类浏览 · 快速直达</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {indexData.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="group bg-background-100 rounded-xl p-5 border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="text-2xl font-bold text-foreground-900 font-heading group-hover:text-primary-500 transition-colors mb-1">
                {item.title}
              </div>
              <span className={`inline-block px-2 py-0.5 rounded text-xs font-medium ${tagColors[item.tag] || 'bg-background-200 text-foreground-600'} whitespace-nowrap`}>
                {item.tag}
              </span>
              <div className="mt-2 text-xs text-foreground-400">{item.count}</div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}